export default class SliceFilter {
    public static transform(text: string | number, start: number, end: number): string {
        return (String(text || '')).slice(start, end);
    }
}
